import { render } from "./CallRoomElement.vue.js?vue&type=template&id=f43d8c5c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRoomElement.vue?vue&type=template&id=f43d8c5c"
import script from "./CallRoomElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRoomElement.vue?vue&type=script&lang=js"
export * from "./CallRoomElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRoomElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/call-room/CallRoomElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f43d8c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f43d8c5c', __exports__)) {
    api.reload('f43d8c5c', __exports__)
  }
  
  module.hot.accept("./CallRoomElement.vue.js?vue&type=template&id=f43d8c5c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallRoomElement.vue?vue&type=template&id=f43d8c5c", () => {
    api.rerender('f43d8c5c', render)
  })

}


export default __exports__